module.exports = __webpack_public_path__ + "static/media/purityx-2.2e78cd84.png";